import AgenciesPage from 'client/common/pages/agencies';

import './index.css';

export default AgenciesPage;
